import { useNavigate } from 'react-router-dom';

import useCopy from 'lib/hooks/useCopy';

import Icon from 'components/shared/Icon/Icon';

const SelfScheduling = ({ practice, isServicesAvailable }) => {
  const navigate = useNavigate();
  const { copyToClipboard } = useCopy({ isText: false });

  const handleCopy = (token) =>
    copyToClipboard(`${window.location.protocol}//${window.location.host}/book?token=${token}`);

  return (
    <div className="flex w-full items-center justify-between gap-5 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-neutral-100 py-5">
      <div className="flex w-1/2 flex-col gap-5 text-sm">
        <span className="font-500">Self Scheduling</span>
        {practice?.token && isServicesAvailable ? (
          <div
            className="flex cursor-pointer items-center gap-2"
            onClick={() => handleCopy(practice?.token)}>
            <Icon icon="copy-mono" />
            <p className="text-neutral-500">Self Scheduling Link</p>
          </div>
        ) : (
          <p className="flex w-max cursor-pointer text-neutral-500">
            Self scheduling unavailable.&nbsp;
            <span onClick={() => navigate('/portal/settings')} className="underline">
              Click here
            </span>
            &nbsp; to add a service and assign practitioners.
          </p>
        )}
      </div>
    </div>
  );
};

export default SelfScheduling;
